import React from "react";
import { getFieldPath } from "utils/form";
import Toggle from "../common/Toggle";

const SettingsFields = ({ name }) => (
  <Toggle
    description="Must be checked to complete checkout."
    name={getFieldPath(name, "validation.required")}
  />
);

export default SettingsFields;
